import { HeaderText } from '@etiquette-ui/dynamic-table-components';
import styled from 'styled-components';

const ResponsiveHeaderText = styled(HeaderText)`
    @media (max-width: 768px) {
        font-size: 14px !important;
    }
`;

export default ResponsiveHeaderText;